'use client'

export * from './faqList'
export * from './header'
